const DEFAULT_MARKETING_DEV_URL = 'http://localhost:4321';
const DEFAULT_MARKETING_PROD_URL = 'https://we-tree.app';

function stripTrailingSlash(url: string): string {
  return url.replace(/\/$/, '');
}

/**
 * Base URL for the marketing site (privacy, terms, etc.).
 * App runs on my.we-tree.app / localhost:5173 — legal pages live on we-tree.app / localhost:4321.
 */
export function getMarketingSiteUrl(): string {
  const configured = import.meta.env.VITE_MARKETING_SITE_URL?.trim();
  if (configured) {
    return stripTrailingSlash(configured);
  }

  if (typeof window !== 'undefined') {
    const { hostname, protocol } = window.location;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return DEFAULT_MARKETING_DEV_URL;
    }

    if (hostname.endsWith('we-tree.app')) {
      return `${protocol}//we-tree.app`;
    }
  }

  return import.meta.env.DEV ? DEFAULT_MARKETING_DEV_URL : DEFAULT_MARKETING_PROD_URL;
}

export function getPrivacyPolicyUrl(): string {
  return `${getMarketingSiteUrl()}/privacy`;
}

export function getTermsUrl(): string {
  return `${getMarketingSiteUrl()}/terms`;
}

export function getRefundPolicyUrl(): string {
  return `${getMarketingSiteUrl()}/refund`;
}

export function getCookiesPolicyUrl(): string {
  return `${getMarketingSiteUrl()}/privacy#cookies`;
}

/** Use on marketing-site links when they may be cross-origin (prod or local dev). */
export function marketingLinkProps(href: string): {
  href: string;
  target?: '_blank';
  rel?: string;
} {
  if (typeof window === 'undefined') {
    return { href, target: '_blank', rel: 'noopener noreferrer' };
  }

  const isCrossOrigin = new URL(href).origin !== window.location.origin;
  return isCrossOrigin ? { href, target: '_blank', rel: 'noopener noreferrer' } : { href };
}
